import { BrowseInventory } from '../../views';

const BrowseRoute = () => {
  return (
    <BrowseInventory />
  );
};

export default BrowseRoute;
